/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListOrganizationRemoteSessionIssuerEMAServicesSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListOrganizationRemoteSessionIssuerEMAServicesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListOrganizationRemoteSessionIssuerEMAServicesSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionIssuerEMAServicesSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionIssuerEMAServicesSecurity$Outbound,
    ListOrganizationRemoteSessionIssuerEMAServicesSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listOrganizationRemoteSessionIssuerEMAServicesSecurityToJSON(
  listOrganizationRemoteSessionIssuerEMAServicesSecurity:
    ListOrganizationRemoteSessionIssuerEMAServicesSecurity,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionIssuerEMAServicesSecurity$outboundSchema.parse(
      listOrganizationRemoteSessionIssuerEMAServicesSecurity,
    ),
  );
}

/** @internal */
export type ListOrganizationRemoteSessionIssuerEMAServicesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionIssuerEMAServicesRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionIssuerEMAServicesRequest$Outbound,
    ListOrganizationRemoteSessionIssuerEMAServicesRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function listOrganizationRemoteSessionIssuerEMAServicesRequestToJSON(
  listOrganizationRemoteSessionIssuerEMAServicesRequest:
    ListOrganizationRemoteSessionIssuerEMAServicesRequest,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionIssuerEMAServicesRequest$outboundSchema.parse(
      listOrganizationRemoteSessionIssuerEMAServicesRequest,
    ),
  );
}
